module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAW0lEQVQYlY2QwQmAQAwEVx+CV7VnKz6sxC70JRahn5GF8+dFB0JgGUISAa4eyMAKnKXnkstCAhbecZ4sjRXhYbDk0RFb4x0kdapztZL2QDCHpflDmn5fF/8JdANpZ87V79O3CgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu-dot.png
// module id = 1386
// module chunks = 28